import React from 'react';
import styles from './DoneButton.module.css';


export default function DoneButton() {
  return (
    <div className={styles.buttonContainer}>
      <button type="submit" className={styles.doneButton}>Done</button>
    </div>
  );

};